export const ArticlePageTranslations = {
  articlePageTranslations: {
    likeThisArticle: 'Like this article? Share on social.',
    moreFromCollection: 'More from this collection',
    moreFromSeries: 'More from this series',
    copiedToClipboard: 'Copied to clipboard!',
  },
};
